import memoizeOne from 'memoize-one';

import type { LoomProviderOptions, VideoMeta } from '@atlaskit/editor-plugins/loom';

import type { OpenLoomRecorderParams } from '@confluence/loom-utils/entry-points/useLoomRecorderEntryPoint';

export type LoomProviderConfig = {
	openLoomRecorder: (params: OpenLoomRecorderParams) => Promise<void>;
};

export const getLoomProvider = memoizeOne((config: LoomProviderConfig): LoomProviderOptions => {
	return {
		getClient: async () => ({
			status: 'loaded',
			client: {
				attachToButton: ({ button, onInsert }) => {
					button.addEventListener('click', () => {
						void config.openLoomRecorder({
							onInsert: (_, video: VideoMeta) => {
								onInsert(video);
							},
							// intentionally not localized because Loom RecordSDK does not support i18n
							insertButtonText: 'Insert Loom video',
						});
					});
				},
			},
		}),
	};
});
